const i18n = {
    textAreaWithTemplateLabel: {
		0 : "Текст шаблону",
		1 : "Тэкст шаблона"
	},
	textAreaWithTemplateMessage: {
		0 : "Патрабуецца тэкст шаблону!",
		1 : "Требуется текст шаблона!"
	},
	textAreaWithTemplateButtonLabel: {
		0 : "Выбраць шаблон",
		1 : "Выбрать шаблон"
	},
}
export default i18n